<loading-bar [label]="'Loading'" *ngIf="loading" />
<loading-bar [label]="'Saving'" *ngIf="saving" />

<div class="error-message" *ngIf="error">{{error}}</div>

<div class="details-section" *ngIf="editModel">
    <div class="section-header">Technical data</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row">
            <div class="col1">IP Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.ipClass"></div>
        </div>
        <div class="row">
            <div class="col1">IC Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.icClass"></div>
        </div>
        <div class="row">
            <div class="col1">IM Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.imClass"></div>
        </div>
        <div class="row">
            <div class="col1">Insulation Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.insulationClass"></div>
        </div>
        <div class="row">
            <div class="col1">Temperature Rise Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.temperatureRiseClass"></div>
        </div>
        <div class="row">
            <div class="col1">Ambient temp [°C]:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.ambientTemperature"></div>
        </div>
        <div class="row">
            <div class="col1">Installation altitude [m]:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.altitude"></div>
        </div>
        <div class="row">
            <div class="col1">Poles High:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.polesHigh"></div>
        </div>
        <div class="row">
            <div class="col1">Poles Low:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.polesLow"></div>
        </div>
        <div class="row">
            <div class="col1">Type of duty:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.typeOfDuty"></div>
        </div>
        <div class="row">
            <div class="col1">EX-Protection:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.exProtection"></div>
        </div>
        <div class="row">
            <div class="col1">Gas Group:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.gasGroup"></div>
        </div>
        <div class="row">
            <div class="col1">Temperature Class:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.temperatureClass"></div>
        </div>
        <div class="row">
            <div class="col1">Certificate number:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.certificateNumber"></div>
        </div>
        <div class="row">
            <div class="col1">Bearing DE:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.bearing"></div>
        </div>
        <div class="row">
            <div class="col1">Bearing NDE:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.nonBearing"></div>
        </div>
        <div class="row">
            <div class="col1">Net Weight:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.netWeight"></div>
        </div>
        <div class="row">
            <div class="col1">Gross Weight:</div>
            <div class="col"><input matInput type="number" [(ngModel)]="editModel.grossWeight"></div>
        </div>
        <div class="row">
            <div class="col1">Atex category:</div>
            <div class="col"><input matInput [(ngModel)]="editModel.atexCategory"></div>
    </div> 
    </div>
</div>

<div class="details-section" *ngIf="editFrequencyModel">
    <div class="section-header">IE Classes</div>
    <div class="section-content">
        <div class="section-tab">
            <table class="mat-elevation-z2">
                <thead>
                    <tr>
                        <th>Frequency</th>
                        <th>IE Class</th>
                        <th>50%</th>
                        <th>75%</th>
                        <th>100%</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>50 Hz</td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.IeClass50Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.PartialLoad50Percent50Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.PartialLoad75Percent50Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.FullLoad50Hz"></td>
                    </tr>
                    <tr>
                        <td>60 Hz</td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.IeClass60Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.PartialLoad50Percent60Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.PartialLoad75Percent60Hz"></td>
                        <td><input matInput [(ngModel)]="editFrequencyModel.FullLoad60Hz"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="details-section" *ngIf="editModel">
    <div class="section-header">Electrical data</div>
    <div class="section-content">
        <div class="section-tab">
            <button mat-raised-button color="primary" (click)="addElectricalData()">Add Electrical Data</button>
            <mat-table [dataSource]="editModel.electricalData" class="mat-elevation-z2">
                <ng-container matColumnDef="printFlag">
                    <mat-header-cell *matHeaderCellDef><b>Print Flag</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.printFlag"></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="stampFlag">
                    <mat-header-cell *matHeaderCellDef><b>Stamp Flag</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.stampFlag"></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="voltage">
                    <mat-header-cell *matHeaderCellDef><b>Voltage [V]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.voltage">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="frequency">
                    <mat-header-cell *matHeaderCellDef><b>Frequency [Hz]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.frequency">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="connection">
                    <mat-header-cell *matHeaderCellDef><b>Connection</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput [(ngModel)]="element.connection">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="powerOutput">
                    <mat-header-cell *matHeaderCellDef><b>Power [kW]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.powerOutput">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="speed">
                    <mat-header-cell *matHeaderCellDef><b>Speed [r/min]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.speed">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="efficiency">
                    <mat-header-cell *matHeaderCellDef><b>Efficiency %</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.efficiency">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="powerFactor">
                    <mat-header-cell *matHeaderCellDef><b>Power Factor</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.powerFactor">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="current">
                    <mat-header-cell *matHeaderCellDef><b>Current [A]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.current">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="stallTime">
                    <mat-header-cell *matHeaderCellDef><b>Stall Time</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.stallTime">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="torque">
                    <mat-header-cell *matHeaderCellDef><b>Torque [Nm]</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.torque">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="isIn">
                    <mat-header-cell *matHeaderCellDef><b>Is In</b></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input matInput type="number" [(ngModel)]="element.isIn">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef><b>Actions</b></mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index">
                        <button mat-icon-button color="warn" (click)="removeElectricalData(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="electricalDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: electricalDisplayedColumns"></mat-row>
            </mat-table>
        </div>
    </div>
</div>

<div class="details-section" *ngIf="editModel">
    <div class="section-header">Variants</div>
    <div class="section-content">
        <div class="section-tab">
            <button mat-raised-button color="primary" (click)="addVariant()">Add Variant</button>
            <mat-table [dataSource]="editModel.variants" class="mat-elevation-z1">
                <ng-container matColumnDef="code">
                    <mat-header-cell *matHeaderCellDef><b>Variant Code</b></mat-header-cell>
                    <mat-cell *matCellDef="let variant">
                        <input matInput [(ngModel)]="variant.code">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description">
                    <mat-header-cell *matHeaderCellDef><b>Description</b></mat-header-cell>
                    <mat-cell *matCellDef="let variant">
                        <input matInput [(ngModel)]="variant.description">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="instruction">
                    <mat-header-cell *matHeaderCellDef><b>Instruction</b></mat-header-cell>
                    <mat-cell *matCellDef="let variant">
                        <input matInput [(ngModel)]="variant.instruction">
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef><b>Actions</b></mat-header-cell>
                    <mat-cell *matCellDef="let variant; let i = index">
                        <button mat-icon-button color="warn" (click)="removeVariant(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="variantDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: variantDisplayedColumns"></mat-row>
            </mat-table>
        </div>
    </div>

    <div class="button-row">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">Save</button>
      <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
  </div>
</div>

<div *ngIf="!loading && !data">
    <h3>Cannot load technical details</h3>
</div>